import type { SubTemplateProps } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'

export function DenseTemplate({ display, controls, slots }: SubTemplateProps) {
  return (
    <>
      <div className={`md-dense-row mb-1.5 rounded-[5px] border border-l-4 border-[#d8e0e6] border-l-[#168a6a] bg-white px-2.5 py-[7px] text-[#202c35]${display.isChecked ? ' md-dense-row--checked border-[#168a6a] bg-[#f2fbf7]' : ''}`}>
        <div className="md-dense-row__line flex items-center gap-2 max-[640px]:flex-wrap">
          <div className="md-dense-row__actions flex flex-[0_0_auto] gap-[5px]">
            {controls.actions.check}
            {controls.actions.favorite}
          </div>
          <div className="md-dense-row__title min-w-0 flex-1 overflow-hidden text-ellipsis whitespace-nowrap font-semibold">{controls.content.title}</div>
          <div className="md-dense-row__time flex-[0_0_auto] text-xs text-[#697784] max-[640px]:ml-[31px] max-[640px]:basis-full">{controls.content.time}</div>
        </div>
        <div className="md-dense-row__text mt-[3px] text-[13px] leading-[1.35] text-[#34424d] [overflow-wrap:anywhere]">{controls.content.text}</div>
        <div className="md-dense-row__meta mt-1 flex min-h-4 gap-2.5 text-xs text-[#556575]">
          {controls.links.answers}
          {controls.links.submsges}
        </div>
      </div>
      {slots.allChildren}
    </>
  )
}
